document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header');
  const banner = header?.querySelector('[x-ref="banner"]') || document.querySelector('.banner-wrapper');
  const nav = header?.querySelector('.navbar');
  const menuContainer = header?.querySelector('.header-primary-menu-container');
  const ham = header?.querySelector('.ham');
  const menuButton = header?.querySelector('button[aria-label="Valikkopainike"]');

  /* ---- Scroll logic ---- */
  const updateScrolled = () => {
    if (!banner || !nav) return;

    // 1. Calculate the base trigger point
    const bannerBottom = banner.offsetTop + banner.offsetHeight;
    
    // 2. Determine offset based on screen size
    // Using 1024px (lg) as the desktop threshold, but adjust to 1280px if preferred
    const isDesktop = window.innerWidth >= 1280;
    
  };

  window.addEventListener('scroll', updateScrolled, { passive: true });
  window.addEventListener('resize', updateScrolled);
  updateScrolled(); // initial state

  /* ---- Mobile menu toggle ---- */
  if (menuButton && menuContainer && ham) {
    menuButton.addEventListener('click', () => {
      const isOpen = menuContainer.classList.contains('open');
      menuContainer.classList.toggle('open', !isOpen);
      menuContainer.classList.toggle('flex', !isOpen);
      menuContainer.classList.toggle('hidden', isOpen);
      ham.classList.toggle('active', !isOpen);
    });

    // Close menu automatically on resize ≥1280px
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 1280 && menuContainer.classList.contains('open')) {
        menuContainer.classList.remove('open', 'flex');
        menuContainer.classList.add('hidden');
        ham.classList.remove('active');
      }
    });
  }

});
